module.exports = __webpack_public_path__ + "static/media/afn.d9eb3818.png";